import { type TSubscription as TApiSubscription } from '@core/api'

import { type TSubscription } from '@core/models'

import { convertPrice } from './convertPrice'

export const convertSubscription = (subscription: TApiSubscription): TSubscription => {
    return {
        status: subscription.status,
        price: subscription.price,
        dateCreated: subscription.date_created,
        dateUpdated: subscription.date_updated,
        dateToBeCancelled: subscription.date_cancel,
        dateCancelled: subscription.date_cancelled,
        dateExpire: subscription.date_expire,
        dateTrialEnd: subscription.date_trial_end,
        priceModel: convertPrice(subscription.price_model),
        paymentMethod: subscription.payment_method,
        provider: subscription.provider,
        hasExtendedTrial: subscription.has_extended_trial,
        datePausedUntil: subscription.date_paused_until,
    }
}
